import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
export default {
  data: () => ({
    name: "Country",
    mainPage: "",
    subPage: "",
    pageUrl: "",
    backSlash: true,
    userId: EncryptUtility.localStorageDecrypt("userID"),
    refresh: true,
    totalRecords: 0,
    searchGenericProj: "",
    isActive: 1,
    genericProjData: [],
    genericProjAddDialog: false,
    genericProjName: "",
    genericProjUpdateFormDialog: false,
    updateIsActive: 1,
    updateGenericProjName: "",
    updateGenericProjDet: [],
    headerGenericProj: [
      {
        text: "Name",
        value: "Name",
        align: "start",
        class: "primary customwhite--text",
      },
      {
        text: "Created Date",
        value: "CreatedDate",
        class: "primary customwhite--text",
      },
      {
        text: "Created By",
        value: "CreatedBy",
        class: "primary customwhite--text",
      },
      {
        text: "Modified Date",
        value: "ModifiedDate",
        class: "primary customwhite--text",
      },
      {
        text: "Modified By",
        value: "ModifiedBy",
        class: "primary customwhite--text",
      },
      {
        text: "Active",
        value: "active",
        class: "primary customwhite--text",
      },
      {
        text: "Actions",
        value: "actions",
        class: "primary customwhite--text",
      },
    ],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.getGenericProj();
  },
  mounted() {},
  methods: {
    //Reset Function
    resetFunction() {
      this.totalRecords = 0;
      this.searchGenericProj = "";
      this.isActive = 1;
      this.genericProjData = [];
      this.genericProjName = "";
      this.genericProjAddDialog = false;
      this.genericProjUpdateFormDialog = false;
      this.updateIsActive = 1;
      this.updateGenericProjName = "";
      this.updateGenericProjDet = [];
      this.getGenericProj();
    },
    //On close of popup
    onCancel() {
      if (this.genericProjAddDialog) {
        this.genericProjName = "";
        this.$refs.genericProjAddForm.resetValidation();
        this.genericProjAddDialog = false;
      }
      if (this.genericProjUpdateFormDialog) {
        this.updateGenericProjName = "";
        this.updateIsActive = 1;
        this.$refs.genericProjUpdateForm.resetValidation();
        this.genericProjUpdateFormDialog = false;
      }
    },
    //Add a new carrier button
    addGenericProj() {
      if (this.$refs.genericProjAddForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        let obj = {
          Name: this.genericProjName,
          IsActive: 1,
          CreatedBy: parseInt(this.userId),
        };
        this.axios
          .post("cr/cr_generic_project_master_insert", obj)
          .then((response) => {
            if (response.status == 200) {
              this.onCancel();
              this.getGenericProj();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Update carrier button
    updateGenericProj() {
      if (this.$refs.genericProjUpdateForm.validate()) {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        let obj = {
          ProjectGenericId: parseInt(this.updateGenericProjDet[0]?.ProjectGenericId),
          Name: this.updateGenericProjName,
          IsActive: parseInt(this.updateIsActive),
          ModifiedBy: parseInt(this.userId),
        };
        this.axios
          .post("cr/cr_generic_project_master_update", obj)
          .then((response) => {
            if (response.status == 200) {
              this.onCancel();
              this.getGenericProj();
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Carrier Details
    genericProj(item) {
      this.updateGenericProjDet = [];
      this.updateGenericProjDet.push(item);
      this.updateGenericProjName = this.updateGenericProjDet[0]?.Name;
      this.updateIsActive = this.updateGenericProjDet[0]?.IsActive == true ? 1 : 0;
      this.genericProjUpdateFormDialog = true;
    },
    //Get Carrier List
    getGenericProj() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.axios
        .get("cr/cr_generic_project_master_list?IsActive=" + this.isActive)
        .then((response) => {
          if (response.status == 200) {
            let responseData = JSON.parse(response.data.body.message);
            if (responseData !== null) {
              const newArr = responseData.map((obj) => {
                return {
                  ...obj,
                  CreatedDate: Utility.displayDateFormat(obj.CreatedDate),
                  ModifiedDate: obj.ModifiedDate !== null ? Utility.displayDateFormat(obj.CreatedDate) : "",
                };
              });
              this.genericProjData = newArr;
              this.totalRecords = newArr.length;
            } else {
              this.genericProjData = [];
              this.totalRecords = 0;
              let Alert = {
                type: "error",
                isShow: true,
                message: "No data based on the selected criteria",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //On Click of Favorite icon
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
